import { render, staticRenderFns } from "./fgtpwd_2.vue?vue&type=template&id=3ef7c814&scoped=true&"
import script from "./fgtpwd_2.vue?vue&type=script&lang=js&"
export * from "./fgtpwd_2.vue?vue&type=script&lang=js&"
import style0 from "./fgtpwd_2.vue?vue&type=style&index=0&id=3ef7c814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef7c814",
  null
  
)

export default component.exports